<template>
    <validation-observer v-if="cartCount > 0" ref="form" v-slot="{ passes, invalid }">
        <slot :form="form" :invalid="invalid"/>
        <validation-provider
            vid="card"
            name="card"
            v-slot="{ errors, required }"
            class="mb-4"
        >
            <div v-show="needsPayment">
                <bc-label class="required">Credit or Debit Card</bc-label>
                <div id="card-element"
                     class="px-3 py-2.5 border border-gray-200 bg-white dark:bg-gray-900 dark:border-gray-700 shadow-sm block rounded transition duration-200 ease-in-out focus:ring-2 focus:ring-gray-500 focus:outline-none focus:ring-opacity-25 disabled:opacity-50 disabled:cursor-not-allowed focus:border-gray-500"></div>
                <bc-error v-show="errors.length">{{ errors[0] }}</bc-error>
            </div>
        </validation-provider>

        <slot name="extra" :form="form" :invalid="invalid"/>

        <div v-show="paymentError" class="text-white px-3 py-2 border-0 rounded relative mb-4 bg-red-500">
            {{ paymentError }}
        </div>

        <bc-button variant="primary" :disabled="loading || invalid || paymentError !== false" type="button" @click="passes(handlePayment)">
            <span v-if="loading" class="inline-flex items-center">
                <svg class="animate-spin -ml-2 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Processing...
            </span>
            <span v-else-if="needsPayment">Pay now - £{{ cartTotal }}</span>
            <span v-else>Enrol Today</span>
        </bc-button>
    </validation-observer>
</template>
<script>

import {mapGetters} from 'vuex'
import BcAlert from "../../admin/components/Alert";

export default {
    name: 'AppCheckout',
    components: {BcAlert},
    props: {
        pk: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            stripe: false,
            cardElement: null,
            loading: false,
            paymentError: false,
            form: {},
            items: [],
            dark: {
                base: {
                    color: '#ffffff',
                    fontWeight: '400',
                    fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                    ':-webkit-autofill': {
                        // color: '#fce883',
                    },
                    '::placeholder': {
                        color: '#69717f',
                    },
                },
                invalid: {
                    //iconColor: '#FFC7EE',
                    //color: '#FFC7EE',
                },
            },
            light: {
                base: {
                    color: '#3e4857',
                    fontWeight: '400',
                    fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                    ':-webkit-autofill': {
                        // color: '#fce883',
                    },
                    '::placeholder': {
                        // color: '#69717f',
                    },
                },
                invalid: {
                    //iconColor: '#FFC7EE',
                    //color: '#FFC7EE',
                },

            },
        }
    },
    computed: {
        ...mapGetters('cart', ['cartCount', 'cartProducts', 'cartSubTotal', 'cartTotal', 'cartDiscount', 'cartDiscountAmount']),
        ...mapGetters({theme: 'theme/getTheme'}),

        needsPayment() {
            return this.cartTotal > 0;
        },
    },
    mounted() {
        this.items = this.cartProducts.map(item => {
            return {
                title: item.title,
                price: item.price,
                quantity: item.quantity,
                sku: item.sku,
                option: {
                    programme_id: item.id,
                    group_id: item.option ? item.option.id : 0
                }
            }
        })
        if (this.items.length) {
            this.setUpStripe()
        }
    },
    methods: {
        listenForErrors() {
            const vm = this
        },
        setUpStripe() {
            if (window.Stripe === undefined) {
                alert('Stripe V3 library not loaded!')
            } else {
                this.stripe = window.Stripe(this.pk)
                const elements = this.stripe.elements()
                // Set up Stripe.js and Elements to use in checkout form
                const style = this.theme === 'dark' ? this.dark : this.light
                this.cardElement = elements.create('card', {style})
                this.cardElement.mount('#card-element')
                this.listenForErrors()
            }
        },

        Pay() {
            // this will trigger the process
            if (this.loading === true) {
                return;
            }

            this.loading = true;
            this.paymentError = false;

            this.stripe.createPaymentMethod({
                type: 'card',
                card: this.cardElement,
                billing_details: {
                    // Include any additional collected billing details.
                    name: this.form.name.trimEnd(),
                    email: this.form.email.trimEnd(),
                },
            }).then((result) => {
                // stripe response
                if (result.error) {
                    this.setError(result.error.message);
                } else {
                    this.form.items = this.items;
                    this.form.sub_total = this.cartSubTotal;
                    this.form.total = this.cartTotal;
                    this.form.payment_method_id = result.paymentMethod.id;

                    if (this.cartDiscountAmount > 0) {
                        this.form.discount = this.cartDiscount;
                    }

                    this.loading = true;

                    axios.post('/api/checkout', this.form)
                        .then((response) => {
                            if (response.data.error) {
                                this.setError(response.data.error);
                            } else if (response.data.requires_action) {
                                // Use Stripe.js to handle required card action
                                this.loading = true
                                this.stripe.handleCardAction(
                                    response.data.payment_intent_client_secret
                                ).then((result) => {
                                    if (result.error) {
                                        this.setError(result.error.message);
                                    } else {
                                        // The card action has been handled
                                        // The PaymentIntent can be confirmed again on the server
                                        delete this.form.payment_method_id;

                                        this.form.payment_intent_id = result.paymentIntent.id;

                                        axios.post('/api/checkout', this.form)
                                            .then((response) => {
                                                if (response.data.error) {
                                                    this.setError(response.data.error);
                                                } else {
                                                    this.Success()
                                                }
                                            })
                                            .catch((err) => {
                                                this.setError(err.response.data.error);
                                            })
                                    }
                                });
                            } else {
                                this.Success()
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.setError(err);
                        })
                }
                // end stripe response
            })
        },
        nonPayment() {
            // this will trigger the process
            if (this.loading === true) {
                return
            }

            this.loading = true;

            this.form.items = this.items;
            this.form.sub_total = this.cartSubTotal;
            this.form.total = this.cartTotal;

            if (this.cartDiscountAmount > 0) {
                this.form.discount = this.cartDiscount;
            }

            this.loading = true;

            axios.post('/api/checkout', this.form)
                .then((response) => {
                    if (response.data.error) {
                        this.setError(response.data.error);
                    } else {
                        /// success
                        this.Success();
                    }
                })
                .catch((err) => {
                    this.setError(err.response.data.errors);
                })
        },
        handlePayment() {
            if (this.cartTotal === 0) {
                this.nonPayment();
            } else {
                this.Pay();
            }
        },
        Success() {
            this.form = {} // Clear input fields.
            // this.$nextTick(() => this.$refs.form.reset())
            this.$store.dispatch('cart/clear');
            this.$store.dispatch('cart/clearDiscount');

            this.loading = false;
            this.paymentError = false;

            this.$dialog.alert({
                title: 'Thank you for your payment',
                text: this.$i18n.tc('Please click button below to access your programme'),
                okButtonText: this.$i18n.tc('Go to my programmes'),
                icon: 'info',
                clickToClose: false,
                escToClose: false,

            }).then((result) => {
                window.location = '/account/programmes'
            })
        },
        setError(error) {
            this.paymentError = error;
            this.loading = false;

            setTimeout(() => {
                this.paymentError = false;
            }, 5000);
        }
    }
}
</script>
